import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { api } from '@/lib/api'
import { useStorefrontProducts } from '@/lib/useStorefrontCategories'
import type { Tier } from '@/types'
import CategoryBrowser from '@/components/storefront/CategoryBrowser'

export default function Products() {
  const [searchParams, setSearchParams] = useSearchParams()
  const category = searchParams.get('category')

  const { data, isLoading } = useStorefrontProducts()
  const tiers = useQuery({
    queryKey: ['storefront-tiers'],
    queryFn: async () => (await api.get<{ data: Tier[] }>('/storefront/tiers')).data.data,
  })

  // Selection lives in the URL here so a category is shareable and the home
  // page's "View all" tiles can deep link straight into one.
  const pick = (next: string | null) => {
    setSearchParams(next ? { category: next } : {}, { replace: true })
  }

  return (
    <div className="pb-4 pt-6">
      <div className="mx-auto w-full max-w-6xl px-5">
        <h1 className="text-3xl font-semibold">Products</h1>
        <p className="mt-1 text-sm text-foreground/60">
          Prices shown are the best flat per-piece rate - your tier applies at checkout
        </p>
      </div>

      <CategoryBrowser
        products={data}
        tiers={tiers.data}
        isLoading={isLoading}
        value={category}
        onChange={pick}
        title={category ?? 'All products'}
      />
    </div>
  )
}
